import React, { ReactNode, createContext, useEffect, useState } from "react";

interface ServiceContextType {
  service: string;
  setService: React.Dispatch<React.SetStateAction<string>>;
}

export const ServiceContext = createContext<ServiceContextType>({
  service: "",
  setService: () => {},
});

const ServiceProvider = ({ children }: { children: ReactNode }) => {
  const storedService = sessionStorage.getItem("service");
  const [service, setService] = useState<string>(storedService ? storedService : "mtn");
  useEffect(() => {
    sessionStorage.setItem("service", service);
  }, [service]);

  return <ServiceContext.Provider value={{ service, setService }}>{children}</ServiceContext.Provider>;
};

export default ServiceProvider;
